// Schedule parsing helpers from the prototype.

export const MOCK_TODAY_INDEX = 3; // Wed (0 = Sun)
export const _DAY_TOKENS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

// Number of days until the next occurrence of dayStr from MOCK_TODAY_INDEX.
// dayStr can be "Mondays" / "Mon" / "Monday" — only the first 3 letters matter.
export const daysUntil = (dayStr) => {
  if (!dayStr) return null;
  const trimmed = dayStr.replace(/s$/, '').slice(0, 3).toLowerCase();
  const target = _DAY_TOKENS.findIndex(d => d.toLowerCase() === trimmed);
  if (target < 0) return null;
  return (target - MOCK_TODAY_INDEX + 7) % 7;
};

// "Mondays · 7pm" → countdown label like "Tonight" / "Tomorrow" / "In 3 days".
export const countdownLabel = (scheduleStr) => {
  const m = (scheduleStr || '').match(/(Sun|Mon|Tue|Wed|Thu|Fri|Sat)[a-z]*/i);
  if (!m) return null;
  const d = daysUntil(m[0]);
  if (d == null) return null;
  if (d === 0) return 'Tonight';
  if (d === 1) return 'Tomorrow';
  return `In ${d} days`;
};

// ============================================================================
// HELPERS
// ============================================================================

